module.exports = __webpack_public_path__ + "static/Vedalken_male_Crosstown_Courier-1bffc177f2a8e9b91d2ac17b9f870a5e.webp";